<div class="flex flex-column mt-4 align-items-center justify-content-center">
  <ng-container *ngIf="cotizacion == undefined; else elseTemplate">
    <div class="flex align-items-center justify-content-center" style="margin-top: 25%;">
      <mat-spinner [diameter]="40"></mat-spinner>
    </div>
    <div class="flex-1 flex align-items-center justify-content-center" style="margin-top: 50px;">
      <h3>Estamos cotizando</h3>
    </div>
    <div class="flex-1 flex align-items-center justify-content-center text-center">
      <h3>Aguarde un instante</h3>
    </div>
  </ng-container>
  <ng-template #elseTemplate>
    <mat-card class="cotizacion mt-4 responsive-card">
      <mat-card-header>
        <div class="text-center header-title">
          <h2>{{ nombre | titlecase }}</h2>
          <p>Esta es tu cotización...</p>
        </div>
      </mat-card-header>
      <div class="text-center" style="background-color: #fff;">
        <img mat-card-image class="mt-4" src="assets/iconos/logosmg.png" alt="SMG Seguros" width="150px">
      </div>
      <mat-card-content class="m-4">
        <h3>Valor Total</h3>
        <h2 class="valor"><strong>$ {{cotizacion?.imp_premio | moneda}}</strong></h2>
        <h3>12 cuotas de</h3>
        <h2 class="valor"><strong>$ {{cotizacion?.imp_cuota | moneda}}</strong></h2>
        <small>+ IIBB en caso de corresponder</small>
      </mat-card-content>
      <mat-card-actions class="justify-content-center">
        <!--<button class="button-asistencia" mat-button>Necesito Asistencia</button>-->
        <button class="button-contratar" mat-button [routerLink]="['../contratar']">La quiero</button>
      </mat-card-actions>
    </mat-card>
  </ng-template>
</div>

